// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"ca785b4a","25":"3d594a58","67":"1eb8face","101":"3edf84b4","302":"3a724045","311":"9bd4045f","325":"ed88e426","404":"efbf597f","561":"2542b22c","585":"a815b189","620":"16436fdb","659":"33b67086","705":"b8f77767","881":"94e27010","925":"f69c24ba","965":"7f5e8bb8"}[chunkId] + ".chunk.js";
};